import { createContext, useReducer } from 'react'
import targetReducer from './TargetReducer'

const TargetContext = createContext()

export const TargetProvider = ({ children }) => {
  const initialState = {
    phase: [],
    target: {},
    loading: false,
  }

  const [state, dispatch] = useReducer(targetReducer, initialState)

  return (
    <TargetContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </TargetContext.Provider>
  )
}

export default TargetContext
